export default "__VITE_ASSET__D3r965iO__"